import type { DashboardPeriodOptions } from '@modules/dashboard/types';
import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_DASHBOARD_ROUTE_NAME = Symbol('admin.dashboard');
export const AFFILIATE_DASHBOARD_ROUTE_NAME = Symbol('affiliate.dashboard');

export const DASHBOARD_LAST_UPDATE_URL = ':namespace/dashboard/last_update';
export const DASHBOARD_STATS_URL = ':namespace/dashboard/get_stats';
export const DASHBOARD_CHART_URL = ':namespace/dashboard/chart';
export const DASHBOARD_MERCHANTS_URL = ':namespace/dashboard/get_merchants';
export const DASHBOARD_TOPS_URL = 'admin/dashboard/tops';
export const DASHBOARD_ARTICLES_URL = 'affiliate/articles/list_articles';
export const DASHBOARD_CHIEF_URL = 'affiliate/dashboard/personal_chief';
export const DASHBOARD_PLAYER_CHECK_URL = 'affiliate/dashboard/players_check';

export const DASHBOARD_LAST_UPDATE_QUERY_KEY = 'dashboard.last-update';
export const DASHBOARD_STATS_QUERY_KEY = 'dashboard.stats';
export const DASHBOARD_CHART_QUERY_KEY = 'dashboard.chart';
export const DASHBOARD_MERCHANTS_QUERY_KEY = 'dashboard.merchants';
export const DASHBOARD_TOPS_QUERY_KEY = 'dashboard.tops';
export const DASHBOARD_ARTICLES_QUERY_KEY = 'dashboard.articles';
export const DASHBOARD_CHIEF_QUERY_KEY = 'dashboard.chief';
export const DASHBOARD_PLAYER_CHECK_QUERY_KEY = 'dashboard.player-check';

export const TRANSLATION_GROUP_DASHBOARD_ADMIN = Symbol('dashboard.admin');
export const TRANSLATION_GROUP_DASHBOARD_AFFILIATE = Symbol('dashboard.affiliate');

export const DASHBOARD_PERMISSIONS = {
  DASHBOARD_LAST_UPDATE: new Permission(
    PermissionsList.admin.DASHBOARD_LAST_UPDATE,
    PermissionsList.affiliate.DASHBOARD_LAST_UPDATE,
  ),

  DASHBOARD_GET_STATS: new Permission(
    PermissionsList.admin.DASHBOARD_GET_STATS,
    PermissionsList.affiliate.DASHBOARD_GET_STATS,
  ),

  DASHBOARD_CHART: new Permission(
    PermissionsList.admin.DASHBOARD_CHART,
    PermissionsList.affiliate.DASHBOARD_CHART,
  ),

  DASHBOARD_TOPS: new Permission(PermissionsList.admin.DASHBOARD_TOPS),

  DASHBOARD_PERSONAL_CHIEF: new Permission(
    undefined,
    PermissionsList.affiliate.DASHBOARD_PERSONAL_CHIEF,
  ),

  DASHBOARD_PLAYERS_CHECK: new Permission(
    undefined,
    PermissionsList.affiliate.DASHBOARD_PLAYERS_CHECK,
  ),
};

export const DASHBOARD_PERIOD_OPTIONS = [
  'yesterday',
  'today',
  'week',
  'last_week',
  'month',
  'last_month',
  'year',
] as const;

export const DASHBOARD_PERIOD_OPTION_DEFAULT: DashboardPeriodOptions = DASHBOARD_PERIOD_OPTIONS[4];

export const DASHBOARD_CHART_ITEM_TYPES = [
  'ggr',
  'ngr',
  'registration_count',
  'first_deposit_count',
  'profit',
  'deposits',
] as const;

export const DASHBOARD_STATS_ADMIN_ITEMS = [
  'deposits',
  'withdrawals',
  'first_deposit_count',
  'registration_count',
  'profit',
  'ngr',
  'deposits_count',
  'withdrawals_count',
] as const;

export const DASHBOARD_STATS_AFFILIATE_ITEMS = [
  'clicks_count',
  'client_count',
  'profit',
  'registration_count',
  'views_count',
  'fixed_payment',
] as const;
